module.exports = __webpack_public_path__ + "media/images/pendleton_logo_white-bef090eee2a56e898740a8fb044527ea.png";